export function parseRoute(hash) {
  const value = hash || '/';
  if (value.startsWith('#/section/')) {
    const section = value.match(/^#\/section\/(work|about|contact)$/);
    return section ? { type: 'home', section: section[1] } : { type: 'missing' };
  }
  const normalized = value.startsWith('#/') ? value.slice(1) : value === '#' ? '/' : value;
  const url = new URL(normalized, 'https://portfolio.invalid');
  const pathname = url.pathname.replace(/\/$/, '') || '/';
  if (pathname === '/') {
    const section = url.hash.slice(1);
    return /^(work|about|contact)$/.test(section) ? { type: 'home', section } : { type: 'home' };
  }
  if (pathname === '/work') return { type: 'work' };
  const study = pathname.match(/^\/work\/([a-z0-9-]+)$/);
  if (study) return { type: 'study', id: study[1] };
  return { type: 'missing' };
}

export function routePath(route) {
  if (route.type === 'study') return `/work/${route.id}/`;
  if (route.type === 'work') return '/work/';
  if (route.type === 'home') return route.section ? `/#${route.section}` : '/';
  return '/404/';
}
